import { CellContext } from '@tanstack/react-table'
import _ from 'lodash'
import { ReactNode } from 'react'
import { FieldArrayWithId } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { ViewportSchema } from 'features/globalSetup/features/viewport/forms/ViewportForm/schema'
import { EditSchema } from 'features/inventory/ad-unit/forms/GeneralForm/schemas/editSchema'
import { MediaTypeSchema } from 'features/inventory/ad-unit/forms/GeneralForm/schemas/mediaTypesSchema'

export const NameCell = ({
  row: {
    original,
    original: {
      viewport: { name },
    },
  },
}: CellContext<FieldArrayWithId<EditSchema>, unknown>): ReactNode => {
  const { t } = useTranslation('features/adUnit', {
    keyPrefix: 'form.general.mediaTypes.viewportList.cells.name',
  })

  const comparableValues: (keyof ViewportSchema)[] = [
    'bannerEnabled',
    'bannerSizes',
    'videoEnabled',
    'playerSize',
    'nativeEnabled',
  ]

  const originalValues: Partial<ViewportSchema> = _.pick(original.viewport, comparableValues)
  const mediaTypeValues: Partial<MediaTypeSchema> = _.pick(original, comparableValues)

  return _.isEqual(originalValues, mediaTypeValues) ? name : t('suffix', { name })
}
